export enum AllLessonsSwitcher {
  Upcoming = 'UPCOMING',
  Past = 'PAST',
}
